import React from 'react'
import { trackPageView } from '~/utils/tracking'

export const useTrackPageView = (page: string) => {
  React.useEffect(() => {
    trackPageView(page)
  }, [page])
}
